import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Contact = () => {
  const contactInfo = [
    {
      icon: 'fas fa-map-marker-alt',
      title: 'Location',
      details: 'Sharjah Research Technology and Innovation Park – Free Zone, Block C, VL14, Sharjah, United Arab Emirates'
    },
    {
      icon: 'fas fa-envelope',
      title: 'Email',
      details: 'info@altofze.com'
    }
  ];

  return (
    <section 
      id="contact" 
      className="py-5"
      style={{ padding: '80px 0' }}
    >
      <Container>
        <Row>
          <Col lg={8} className="mx-auto text-center">
            <h2 
              className="mb-4"
              data-aos="fade-up"
              style={{
                position: 'relative',
                marginBottom: '3rem'
              }}
            >
              Get In Touch
              <div
                style={{
                  content: '""',
                  position: 'absolute',
                  bottom: '-10px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '60px',
                  height: '3px',
                  background: 'linear-gradient(45deg, #007bff, #0056b3)',
                  borderRadius: '2px'
                }}
              />
            </h2>
            <p 
              className="lead mb-5"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Ready to transform your digital presence? Let's discuss your project.
            </p>
            
            <Row className="justify-content-center">
              {contactInfo.map((item, index) => (
                <Col md={5} className="mb-4" key={index}>
                  <div 
                    className="contact-item"
                    data-aos="fade-up"
                    data-aos-delay={index * 200}
                    style={{
                      padding: '1.5rem',
                      transition: 'transform 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    <i 
                      className={`${item.icon} text-primary mb-3`}
                      style={{ fontSize: '2rem' }}
                    />
                    <h5 
                      style={{ 
                        color: '#333', 
                        fontWeight: '600', 
                        marginBottom: '0.5rem' 
                      }}
                    >
                      {item.title}
                    </h5>
                    <p 
                      style={{ 
                        color: '#666', 
                        margin: 0 
                      }}
                    >
                      {item.details}
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
